import { Tooltip } from '@/ui/rapid-ui/tooltip'
import { useTranslation } from 'react-i18next'
import { CandidateBarChart } from './candidate-bar-chart'
import type { DashboardCampaignModel } from './dashboard.vm'

export function ActiveContent(
	{ campaign, hireCount }: { campaign: DashboardCampaignModel; hireCount?: number | null },
) {
	const { t } = useTranslation()
	const hasBarData = campaign.candidatesPerDay != null && campaign.candidatesPerDay.length > 0

	return (
		<div className="flex items-end justify-between gap-3">
			<div>
				<div className="flex items-baseline gap-1">
					<span className="text-3xl font-bold text-grey-900 leading-none">
						{campaign.candidateCount ?? 0}
					</span>
				</div>
				<div className="text-xs text-grey-400 mt-0.5">
					{t('dashboard.candidateLabel', { count: campaign.candidateCount ?? 0 })}
				</div>
			</div>
			{hasBarData && campaign.status == 'active' && (
				<div className="flex flex-col items-end gap-0.5 -my-1">
					<CandidateBarChart
						data={campaign.candidatesPerDay!}
						campaignId={campaign.id}
						status={campaign.status}
					/>
					{campaign.candidatesToday != null && (
						<div className="text-xs text-grey-400">
							<span className="font-medium text-grey-700">{campaign.candidatesToday}</span>{' '}
							{t('dashboard.card.today')}
						</div>
					)}
				</div>
			)}
			{campaign.status === 'completed' && hireCount != null && hireCount > 0
				? (
					<Tooltip content={t('dashboard.card.hires', { count: hireCount })}>
						<div className="size-12 shrink-0 cursor-default">
							<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
								<polygon
									points="24,1 29.43,3.72 35.5,4.08 38.85,9.15 43.92,12.5 44.28,18.57 47,24 44.28,29.43 43.92,35.5 38.85,38.85 35.5,43.92 29.43,44.28 24,47 18.57,44.28 12.5,43.92 9.15,38.85 4.08,35.5 3.72,29.43 1,24 3.72,18.57 4.08,12.5 9.15,9.15 12.5,4.08 18.57,3.72"
									fill="#bbf7d0"
								/>
								<circle cx="24" cy="24" r="14" fill="#16a34a" />
								<path
									d="M15 24 L21 30 L33 17"
									className="scale-75 origin-center"
									stroke="white"
									strokeWidth="4"
									strokeLinecap="round"
									strokeLinejoin="round"
									fill="none"
								/>
							</svg>
						</div>
					</Tooltip>
				)
				: null}
		</div>
	)
}
